import { useEffect, useRef } from "react";

// Textarea ridimensionabile che ricorda l'altezza impostata dall'utente (per storageKey).
export default function ResizableNote({ value, onChange, storageKey, testId, className = "" }) {
  const ref = useRef(null);
  const key = `pgp_note_h:${storageKey}`;
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const h = parseInt(localStorage.getItem(key) || "", 10);
    if (h > 0) el.style.height = `${h}px`;
    const ro = new ResizeObserver(() => {
      if (el.offsetHeight > 0) localStorage.setItem(key, String(el.offsetHeight));
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [key]);
  return (
    <textarea ref={ref} value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testId} rows={3}
      className={`mt-1.5 w-full min-h-[4.5rem] resize-y px-3 py-2 rounded-md bg-slate-900/60 border border-slate-700 text-sm text-slate-100 focus:outline-none focus:border-cyan-500/50 ${className}`} />
  );
}
